const signTrainLines = [
  // Line 1
  "Trains hum through the dusk—\nEchoes of unspoken thoughts\nrattle down the tracks.",
  
  // Line 2
  "Steel on ancient stone,\na schedule older than dust—\nyet still it arrives.",
  
  // Line 3
  "A whistle whispers—\nnot a warning, just goodbye,\ntoo fast to regret.",
  
  // Line 4
  "Beneath station lights,\nhope waits on a yellow line,\nticket in its teeth.",
];

export default signTrainLines;
